import { Link } from "react-router-dom";
import { ArrowUpRight, Wind, Flower2 } from "lucide-react";
import { Seo } from "@/components/Seo";
import { Reveal, MaskLine } from "@/components/Reveal";
import { GoldButton } from "@/components/ui-kit";
import { images, coursesByCategory } from "@/data/site";

// Light / airy wellness theme page
export default function SalaOlistica() {
  const list = coursesByCategory("olistica");
  return (
    <>
      <Seo title="Yoga, Pilates e Reformer a Lusciano | Body Evolution 2.0" description="Sala olistica dedicata a Yoga, Pilates, Posturale e Reformer per migliorare postura, mobilità, equilibrio e benessere." />

      <section className="relative h-[62vh] min-h-[460px] flex items-end overflow-hidden">
        <img src={images.holistic} alt="Sala olistica" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-ivory via-ivory/50 to-ivory/10" />
        <div className="relative z-10 max-w-[1400px] mx-auto w-full px-5 lg:px-10 pb-16">
          <Reveal><div className="label text-gold flex items-center gap-3"><span className="h-px w-8 bg-gold/60" /><Flower2 size={16} /> Sala Olistica</div></Reveal>
          <h1 className="mt-5 font-display font-medium tracking-tight text-4xl sm:text-5xl lg:text-6xl text-ink-800 max-w-3xl">
            <MaskLine delay={0.1}>Equilibrio, postura e benessere</MaskLine>
          </h1>
        </div>
      </section>

      <section className="bg-ivory py-20 lg:py-28">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-10">
          <Reveal delay={0.1}>
            <p className="text-ink-800/70 text-lg lg:text-xl leading-relaxed max-w-4xl">
              La Sala Olistica di Body Evolution 2.0 è uno spazio dedicato al benessere profondo, al controllo del corpo,
              alla mobilità e all'equilibrio. Qui l'allenamento incontra la consapevolezza, attraverso discipline pensate
              per migliorare postura, respirazione, flessibilità e qualità del movimento.
            </p>
          </Reveal>

          <div className="mt-16 grid sm:grid-cols-2 gap-6">
            {list.map((c, i) => (
              <Reveal key={c.slug} delay={(i % 2) * 0.1}>
                <Link to={`/corsi/${c.slug}`} data-testid={`olistica-card-${c.slug}`} className="lift group block bg-white border border-black/10 rounded-sm p-8 hover:border-gold">
                  <div className="flex items-center justify-between">
                    <h3 className="font-display text-2xl font-medium text-ink-800 flex items-center gap-2"><Wind size={20} className="text-gold" /> {c.name}</h3>
                    <ArrowUpRight className="text-ink-800/30 group-hover:text-gold transition-colors" />
                  </div>
                  <p className="mt-3 text-ink-800/60 text-sm leading-relaxed">{c.intro}</p>
                  <div className="mt-5 pt-4 border-t border-black/5 space-y-1.5">
                    {c.schedule.map((s, j) => (
                      <div key={j} className="flex justify-between text-xs text-ink-800/60"><span>{s.days}</span><span className="font-semibold text-ink-800">{s.time}</span></div>
                    ))}
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2}><div className="mt-14"><GoldButton to="/contatti">Prenota una prova gratuita</GoldButton></div></Reveal>
        </div>
      </section>
    </>
  );
}
